<template>
  <el-dialog :title="dialogType==0?'添加分组':'编辑分组'" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="分组名称">
          <el-input v-model="form.name" placeholder="请输入分组名称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="savePrograma">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";
  export default {
    name: "addColumnLebel",
    props: ["visible", "dialogType", "dialogContent"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        form: {
          name: ''
        }
      };
    },
    created() {
      if (this.dialogType === 1) {
        this.form.name = this.dialogContent.name
      }
    },
    methods: {
      savePrograma() {
        if (this.form.name === '') {
          this.$message({
            message: '请编辑需要添加的分组名称',
            type: 'warning'
          });
          return
        }
        let url_ = api.tag_group_add;
        let data_ = {}
        data_.name = this.form.name
        if (this.dialogType === 1) {
          url_ = api.tag_group_edit;
          data_.group_id = this.dialogContent.id;
        }
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                let title = '添加分组成功!'
                if (this.dialogType === 1) {
                  title = '编辑分组成功!'
                }
                this.$message({
                  message: title
                });
                this.dialogVisible = false
                this.form.name = ''
                this.$emit('initFn');
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>


